// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"r1 uX","ribbon":"r2 u6","title":"r3 uZ","seasons":"r4 u4","genres":"r5 u5","buttonWrapper":"r6 u1","button":"r7 u2"};